import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { DashboardSearchComponent } from '../dashboard-search.component';

@Component({
  selector: 'app-dashboard-search-touch',
  templateUrl: './dashboard-search-touch.component.html',
  styleUrls: ['./dashboard-search-touch.component.scss'],
})
export class DashboardSearchTouchComponent extends DashboardSearchComponent {
  isMobile =
    this.platformService.platformType ===
    this.platformService.platformEnum.mobile;

  constructor(
    readonly translateService: TranslateService,
    readonly platformService: PlatformService,
  ) {
    super(translateService);
  }
}
